import React from "react";
import PropTypes from "prop-types";

const ValidationMessage = (props) => {

	let className = "validationmessage";

	if (props.type) {
		if (props.type === 'warning') {
			className += " warning";
		}
	}

	return (
		<span className={className} dangerouslySetInnerHTML={{ __html: props.validationMessage }}/>
	);
};

ValidationMessage.propTypes = {
	valdationMessage: PropTypes.string,
	type: PropTypes.oneOf(['warning', 'error'])
};

export default ValidationMessage;
